// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__Yk8IL","list":"BalanceDue_list__3Qb6w","listRow":"BalanceDue_listRow__3DcGC","total":"BalanceDue_total__371VW"};